export const environment = {
  production: true,
  hmr: false,
  apiUrl: 'http://api.platercrm.com',
};
